import * as FastClick from 'fastclick';

export default function initFastClick() {
  FastClick.attach(document.body);
}
